"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientProto = void 0;
class ClientProto {
    constructor(protocol, actions) {
        this.bind = (ws) => {
            this.ws = ws;
        };
        this.unbind = (ws) => {
            if (this.ws === ws) {
                this.ws = undefined;
            }
        };
        this.PROTO_ID = protocol;
        this.actions = actions;
    }
    onAction(action, data) {
        console.info('received', this.PROTO_ID, action, { data });
    }
    send(action, data) {
        var _a;
        (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify(this.serialize(action, data)));
    }
    serialize(action, data) {
        return {
            date: Date.now(),
            protocol: this.PROTO_ID,
            action,
            data
        };
    }
}
exports.ClientProto = ClientProto;
